<template>
  <div class="kpi-card shadow-sm h-100 p-3 position-relative overflow-hidden" :style="{ borderLeft: '4px solid ' + color }">
    <div v-if="loading" class="loading-overlay">
      <b-spinner small :variant="'primary'" style="color: grey !important;"></b-spinner>
    </div>
    <div :class="{'loading-blur': loading}">
      <div class="d-flex justify-content-between">
        <div>
          <p class="text-muted small mb-1">{{ title }}</p>
          <h3 class="font-weight-bold">{{ value }}</h3>
        </div>
        <div class="icon-box" :style="{ backgroundColor: color + '22', color: color }">
          <md-icon>{{ icon }}</md-icon>
        </div>
      </div>
      <p v-if="trend !== undefined" class="small mb-0" :class="trend >= 0 ? 'text-success' : 'text-danger'">
        <md-icon class="v-align-middle" size="16">{{ trend >= 0 ? 'trending_up' : 'trending_down' }}</md-icon>
        {{ Math.abs(trend) }}% from last month
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KpiCard',
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], required: true },
    icon: { type: String, required: true },
    color: { type: String, default: '#007bff' },
    trend: { type: Number, default: undefined },
    loading: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  backdrop-filter: blur(2px);
}
.loading-blur {
  filter: blur(1px);
  opacity: 0.6;
}

.kpi-card {
  background: #ffffff;
  border-radius: 12px;
  border: none;
  transition: transform 0.3s ease;
}

.kpi-card:hover {
  transform: translateY(-5px);
}

.icon-box {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-align-middle {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// KpiCard.vue?28846ca9